import { State, STATES } from 'util/types/states';
import { ErrorMessages } from 'forms/error-messages';
import * as z from 'zod';

export const updateSchoolFormSchema = z.object({
  name: z.string().nonempty(ErrorMessages.Required),
  websiteUrl: z
    .string()
    .regex(/^.*:\/\/.*$/, 'Include protocol (https:// or http://)')
    .nonempty(ErrorMessages.Required)
    .url(),
  streetAddress: z.string().nonempty(ErrorMessages.Required),
  city: z.string().nonempty(ErrorMessages.Required),
  state: z.nativeEnum(STATES as Record<number, State>),
  zipCode: z.string().regex(/^\d{5}$/, ErrorMessages.ZipCode.INVALID),
  aliases: z
    .array(
      z.object({
        value: z.string().nonempty(ErrorMessages.Required),
      }),
    )
    .optional(),
  slug: z.string().nonempty(ErrorMessages.Required),
  isMultiStepApprovalEnabled: z.boolean().optional(),
  isSequentialApprovalEnabled: z.boolean().optional(),
  termsUrl: z
    .string()
    .url({ message: 'Enter a valid URL' })
    .nonempty(ErrorMessages.Required),
  termsDisplayName: z.string().nonempty(ErrorMessages.Required),
});

export type UpdateSchoolForm = z.TypeOf<typeof updateSchoolFormSchema>;
